import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../i18n/LocaleProvider';
import LocaleSwitcher from './LocaleSwitcher';
import { tenant } from '../tenant';

export default function Header() {
  const { t } = useLocale();

  return (
    <header className="sticky top-0 z-30 border-b border-sand/80 bg-beige/85 backdrop-blur supports-[backdrop-filter]:bg-beige/70">
      <div className="container flex h-16 items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3" aria-label={`${tenant.brand} — ${t.brand}`}>
          {/* Top-left logo is the only thing that varies per domain */}
          <img src={tenant.logo} alt={tenant.brand} className={tenant.logoClass} />
          <span className="hidden h-5 w-px bg-sand sm:block" />
          <span className="eyebrow hidden sm:block">{t.brand}</span>
        </Link>
        <LocaleSwitcher />
      </div>
    </header>
  );
}
